import { observer } from "mobx-react-lite"
import { ReactNode } from "react"
import { useStore } from "../../contexts/store"
import { env } from "../../api/api"

import { Box, Typography } from "@mui/material"


const PodImageHeader = ({children}: {children?: ReactNode}) => {
  const { podStore } = useStore()

  const pod = podStore.pod
  if (!pod) return null
  // prevent showing empty default color image header
  if(pod.podColor === undefined || pod.podImageFileId === undefined) return null

  const style = {
    backgroundColor: pod.podImageFileId ? "" : (pod.podColor ? pod.podColor : "primary.main"),
    backgroundImage: 'none',
    backgroundPositionY: 'center',
    backgroundSize: "cover",
    borderRadius: "5px",
    display: "grid",
    gridTemplateColumns: "auto max-content"
  }

  if (pod.podImageFileId) style.backgroundImage = `url(${env.backendBaseUrl}/file/${pod.podImageFileId})`

  return (
    <Box sx={style}>
      <Box sx={{
        bgcolor: 'rgba(0, 0, 0, 0.40)',
        borderRadius: "5px",
        color: 'white',
        padding: '15px 30px 15px 15px',
        margin: "20px",
        width: "fit-content",
        wordBreak: "break-word"
      }}>
        <Typography variant="h6" sx={{fontWeight: 500}}>{pod.name}</Typography>
        {pod.description !== "" &&
          <Typography sx={{fontWeight: 300}} variant="body2">{pod.description}</Typography>
        }
      </Box>
      <Box sx={{margin: "5px 10px"}}>
        {children}
      </Box>
    </Box>
  )
}

export default observer(PodImageHeader)
